var _path, _path2, _ellipse, _ellipse2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOperatorPanel = function SvgOperatorPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.453 14.383H15.97c1.64 0 2.453-.813 2.453-2.422V2.42C18.422.814 17.609 0 15.969 0H2.453Q.002-.002 0 2.422v9.539q.002 2.424 2.453 2.422m.016-1.258c-.781 0-1.211-.414-1.211-1.227V2.484c0-.812.43-1.226 1.21-1.226h13.485c.774 0 1.211.414 1.211 1.226v9.414c0 .813-.437 1.227-1.21 1.227z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M11.013 4.82c0 .987-.732 1.75-1.592 1.75s-1.592-.763-1.592-1.75c0-.986.732-1.75 1.592-1.75s1.592.764 1.592 1.75Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.197,
    cy: 4.82,
    fill: "currentColor",
    rx: 0.461,
    ry: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.644,
    cy: 4.82,
    fill: "currentColor",
    rx: 0.461,
    ry: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.184,
    height: 4,
    x: 3.224,
    y: 8.07,
    stroke: "currentColor",
    strokeWidth: 0.5,
    rx: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.184,
    height: 4,
    x: 7.829,
    y: 8.07,
    stroke: "currentColor",
    strokeWidth: 0.5,
    rx: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.184,
    height: 4,
    x: 12.434,
    y: 8.07,
    stroke: "currentColor",
    strokeWidth: 0.5,
    rx: 0.75
  })));
};
export default SvgOperatorPanel;